import { isNotNullOrWhitespace } from "../../../framework/utils";
import { getNowUnixTimestamp, toDateString } from "../../../framework/utils/date-time";

export const getAnnotatedCustomerNotes = (notes: string, context: string) => {
    if(isNotNullOrWhitespace(notes)) {
        const now = getNowUnixTimestamp();
        return `[${context} ${toDateString(now)}]: ${notes}`;
    }
    return '';
}